import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../elements/Header';
import Footer from '../components/Footer';
import './HomePage.css';

const OurStory = () => {
  return (
    <>
      <div style={{
        backgroundColor: '#181613',
        minHeight: '100vh',
        paddingTop: '150px',
        paddingBottom: '50px'
      }}>
        <Container className="text-center">
          <h1 style={{
            color: '#f7efd7',
            marginBottom: '30px',
            fontWeight: 'bold'
          }}>Our Story</h1>

          {/* Introduction */}
          <Row className="justify-content-center mb-5">
            <Col md={6} className="text-center">
              <p style={{ color: '#f7efd7', fontSize: '1.1rem' }}>
                What do you get when a California boy moves across the country to Georgia to marry the love of his life?
              </p>
              <p style={{ color: '#e43a2b', fontStyle: 'italic', fontWeight: 'bold', marginTop: '10px' }}>
                SURFBOARDS ON THE WALL.....AND Asahi Japanese Steak & Sushi Restaurant.
              </p>
            </Col>
          </Row>

          {/* Restaurant History */}
          <Row className="justify-content-center mb-5">
            <Col md={6} className="text-center">
              <p style={{ color: '#f7efd7', fontSize: '1.1rem' }}>
                Since 2003, Chef Sid's popular restaurant Sid's Asahi Japanese Steak & Sushi Restaurant has delighted locals with a laid back ambiance, friendly service and a delectable menu in the heart of Atlanta's Northside suburbs.
              </p>
              <p style={{ color: '#f7efd7', fontSize: '1.1rem', marginTop: '20px' }}>
                Sid's award winning Sicilian-style Asahi Japanese Steak & Sushi Restaurant is inspired by a childhood growing up in California's Mediterranean climate and eating fresh, delicious Asahi Japanese Steak & Sushi Restaurant at local beaches. When Sid moved to Georgia over 35 years ago, he missed the delicious Asahi Japanese Steak & Sushi Restaurant he so enjoyed as a kid.
              </p>
              <p style={{ color: '#f7efd7', fontSize: '1.1rem', marginTop: '20px' }}>
                Realizing the need for really good Asahi Japanese Steak & Sushi Restaurant in the area, he created Sid's Asahi Japanese Steak & Sushi Restaurant. It wasn't easy in the beginning, but with dedication and the support of his family, Sid's Asahi Japanese Steak & Sushi Restaurant has truly become a regional favorite!
              </p>
              <p style={{ color: '#f7efd7', fontSize: '1.1rem', marginTop: '20px' }}>
                A wise man once said, "Sid's worst Asahi Japanese Steak & Sushi Restaurant will be the BEST Asahi Japanese Steak & Sushi Restaurant in the Southeast"....He was right.
              </p>
            </Col>
          </Row>
        </Container>

        {/* Custom Styles */}
        <style jsx>{`
          h1, h4 {
            font-weight: bold;
          }
          ul {
            padding-left: 0;
          }
          .footer {
            margin-top: 50px;
          }
        `}</style>
      </div>
    </>
  );
};

export default OurStory;
